import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class SolarInverterProducts extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    const products = [
      {
        id: 0,
        image: "assets/img/product-3/atp-105kwh-bess.png",
        badgeText: "New Arrival",
        badgeClass: "bg-green",
        location: "",
        gallery: { photos: 0, videos: 0 },
        price: "",
        duration: "",
        title: "ATP 105kWh BESS",
        type: "Industrial",
        category: "Industrial Energy Solution",
        route: "/industrial-solutions/atp-105kwh-bess",
        description:
          "Rugged 105kWh air-cooled LFP storage for industrial backup and energy management.",
        details: {
          power_output: `50kW`,
          voltage_range: `90%`,
          weight: `1.6 tons`,
          local_warranty: "90%",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for Commercial & Industrial Use.",
        },
      },
      {
        id: 2,
        image: "assets/img/product-3/battery-img-2.5.webp",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "2.5kWh - LiFePO₄ Battery",
        type: "Solar Battery",
        category: "Energy Storage Battery",
        route: "/solar-battery/2.5kwh-lifepo4",
        description:
          "Lithium-ion power wall providing reliable energy storage with flexible mounting options.",
        details: {
          power_output: `100Ah`,
          voltage_range: `25.6V`,
          weight: `30kg`,
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for small-scale solar applications.",
        },
      },
      {
        id: 1,
        image: "assets/img/product-3/battery-img.webp",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "5kWh - LiFePO₄ Battery",
        type: "Solar Battery",
        category: "Energy Storage Battery",
        route: "/solar-battery/5kwh-lifepo4",
        description:
          "Lithium-ion power wall providing reliable energy storage with flexible mounting options.",
        details: {
          power_output: `100Ah`,
          voltage_range: `51.2V`,
          weight: `50kg`,
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for Residential Solar Applications.",
        },
      },
      {
        id: 3,
        image: "assets/img/product-3/inverter-3.5.webp",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "ATP 3.5kW Hybrid - Single Phase",
        type: "Solar Inverter",
        category: "Solar Inverter",
        route: "/solar-inverter/atp-3k-sp",
        description:
          "A high-efficiency solar inverter having dual MPPT tracking, and seamless battery integration.",
        details: {
          power_output: `3,500W`,
          voltage_range: `40-60Vdc`,
          weight: `7.5Kg`,
          local_warranty: "18 Months",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for small-scale solar applications.",
        },
      },

      {
        id: 4,
        image: "assets/img/product-3/inverter-1.webp",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "ATP 6kW Hybrid – Single Phase",
        type: "Solar Inverter",
        category: "Solar Inverter",
        route: "/solar-inverter/atp-6k-sp",
        description:
          "A high-efficiency solar inverter having dual MPPT tracking, and seamless battery integration.",
        details: {
          power_output: `6,000W`,
          voltage_range: `40-60Vdc`,
          weight: `20Kg`,
          local_warranty: "5 Years",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for Residential Solar Applications.",
        },
      },
      {
        id: 5,
        image: "assets/img/product-3/inverter-2.webp",
        badgeText: "For Sale",
        badgeClass: "bg-green---",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "ATP 10kW Hybrid – Single Phase",
        type: "Solar Inverter",
        category: "Solar Inverter",
        route: "/solar-inverter/atp-10k-sp",
        description:
          "A powerful inverter with 10,000W output, dual MPPT tracking, and seamless integration. ",
        details: {
          power_output: `10,000W`,
          voltage_range: `40-60Vdc`,
          weight: `37Kg`,
          local_warranty: "5 Years",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for Residential Solar Applications.",
        },
      },
      {
        id: 6,
        image: "assets/img/product-3/inverter-2.webp",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "ATP 12kW Hybrid – Three Phase",
        type: "Solar Inverter",
        category: "Solar Inverter",
        route: "/solar-inverter/atp-12k-h3p",
        description:
          "A high-performance 3-phase inverter designed for large-scale solar applications.",
        details: {
          power_output: `12,000W`,
          voltage_range: `40-60Vdc`,
          weight: `39Kg`,
          local_warranty: "5 Years",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for Residential/ Commercial Solar Applications.",
        },
      },
       {
        id: 6,
        image: "assets/img/product-3/inverter-20.png",
        badgeText: "For Rent",
        badgeClass: "bg-green",
        location: "Belmont Gardens, Chicago",
        gallery: { photos: 4, videos: 2 },
        price: "$34,900",
        duration: "/Month",
        title: "ATP 20kW Hybrid – Three Phase",
        type: "Solar Inverter",
        category: "Solar Inverter",
        route: "/solar-inverter/atp-20k-h3p",
        description:
          "A high-performance 3-phase inverter designed for large-scale solar applications.",
        details: {
          power_output: `20,000W`,
          voltage_range: `40-60Vdc`,
          weight: `60Kg`,
          local_warranty: "5 Years",
        },
        agent: {
          name: "Atom Power",
          image: "assets/img/blog/author.jpg",
          role: "Ideal for Residential/ Commercial Solar Applications.",
        },
      },
    ];

    return (
      <div>
        <div className="ltn__product-slider-area ltn__product-gutter pt-50">
          <div className="container">
            <div className="row mb-5">
              <div className="col-lg-6 align-self-center">
                <div
                  className="about-us-img-wrap about-img-left"
                  style={{ margin: "auto", width: "70%" }}
                >
                  <img
                    src={publicUrl + "assets/img/others/home-section-2.webp"}
                    alt="About Us Image"
                  />
                  <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3">
                    {/* <div className="ltn__video-img ltn__animation-pulse1">
							<img src={publicUrl+"assets/img/others/8.png"} alt="video popup bg image" />
							<a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/X7R-q9rsrtU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
							<i className="fa fa-play" />
							</a>
						</div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-6 align-self-center">
                <div className="about-us-info-wrap">
                  <div className="section-title-area ltn__section-title-2---">
                    {/* <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                      About Us
                    </h6> */}
                    {/* <h2 className="section-title">
                      <span style={{ fontSize: "24px", fontWeight: "600" }}>
                        On a Path to Build an
                      </span>{" "}
                      <span style={{ fontSize: "32px", fontWeight: "700" }}>
                        Energy Efficient Future
                      </span>
                    </h2> */}
                    <h2
                      className="section-title responsive-title"
                      // style={{
                      //   textAlign: "left",
                      // }}
                    >
                      <span
                        style={{
                          fontSize: "22px",
                          fontWeight: "600",
                          display: "block",
                        }}
                      >
                        On a Path to Build an {""}
                      </span>
                      <span
                        style={{
                          fontSize: "32px",
                          fontWeight: "700",
                          display: "block",
                        }}
                      >
                        Energy Efficient Future
                      </span>
                    </h2>
                    <p>
                      Atom Power (Pvt) Ltd is advancing the future of energy in
                      Pakistan and beyond through innovative, locally developed
                      solutions. We deliver reliable and sustainable energy
                      technologies for residential, commercial, EVs, and broader
                      applications.
                    </p>

                    <p>
                      As a subsidiary of Wavetec—with over 30 years of global
                      technology expertise—Atom Power is well-positioned to
                      contribute to the evolving landscape of energy storage and
                      sustainability.
                    </p>
                  </div>
                  {/* <ul className="ltn__list-item-half clearfix">
                  <li>
                    <i className="flaticon-home-2" />
                    Smart Home Design
                  </li>
                  <li>
                    <i className="flaticon-mountain" />
                    Beautiful Scene Around
                  </li>
                  <li>
                    <i className="flaticon-heart" />
                    Exceptional Lifestyle
                  </li>
                  <li>
                    <i className="flaticon-secure" />
                    Complete 24/7 Security
                  </li>
                </ul>
                <div className="ltn__callout bg-overlay-theme-05  mt-30">
                  <p>
                    "Enimad minim veniam quis nostrud exercitation <br />
                    llamco laboris. Lorem ipsum dolor sit amet"{" "}
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link to="/service" className="theme-btn-1 btn btn-effect-1">
                    OUR SERVICES
                  </Link>
                </div> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title-area ltn__section-title-2--- text-center">
                  {/* <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    Products
                  </h6> */}
                  <h1 className="section-title"> Solar Solutions</h1>
                </div>
              </div>
            </div>

            {/* Products */}
            <div className="row ltn__product-slider-item-three-active slick-arrow-1">
              {products.map((product) => (
                <div key={product.id} className="col-lg-12">
                  <div
                    className="ltn__product-item ltn__product-item-4 text-center---"
                    style={{
                      backgroundColor: "#F2F6F7",
                      boxShadow: "0 1px 6px 0 rgba(32, 33, 36, 0.28)",
                    }}
                  >
                    <div
                      className="product-img go-top"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {product.route === "#" ? (
                        <span style={{ cursor: "default" }}>
                          <img  src={product.image} alt={product.title} />
                        </span>
                      ) : (
                        <Link to={product.route}>
                          <img style={{height:"251px"}} src={product.image} alt={product.title} />
                        </Link>
                      )}
                      {/* <div className="product-badge">
                        <ul>
                          <li className={`sale-badge ${product.badgeClass}`}>
                            {product.badgeText}
                          </li>
                        </ul>
                      </div> */}

                      {/* <div className="product-img-location-gallery">
                        <div className="product-img-location go-top">
                          <ul>
                            <li>
                              <Link to="/contact">
                                <i className="flaticon-pin" />{" "}
                                {product.location}
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="product-img-gallery go-top">
                          <ul>
                            <li>
                              <Link to="/product-details">
                                <i className="fas fa-camera" />{" "}
                                {product.gallery.photos}
                              </Link>
                            </li>
                            <li>
                              <Link to="/product-details">
                                <i className="fas fa-film" />{" "}
                                {product.gallery.videos}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div> */}
                    </div>
                    <div className="product-info">
                      <div className="product-price">
                        {/* <span>
                          {product.price}
                          <label>{product.duration}</label>
                        </span> */}
                        <h6>{product?.category}</h6>
                      </div>
                      <h2
                        className="product-title go-top"
                        style={{ fontSize: "19px" }}
                      >
                        {product.route === "#" ? (
                          <span>{product.title}</span>
                        ) : (
                          <Link to={product.route}>{product.title}</Link>
                        )}
                      </h2>
                      <div className="product-description">
                        <p>{product.description}</p>
                      </div>
                      <ul
                        className="ltn__list-item-2 ltn__list-item-2-before"
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                          justifyContent: "flex-start",
                        }}
                      >
                        <li>
                          <span>{product.details.power_output} </span>
                          {product.type == "Industrial"
                            ? "Built-in inverter"
                            : product.type == "Solar Battery"
                              ? "Capacity"
                              : "Rated Power"}
                        </li>
                        <li>
                          <span>
                            {product.type == "Solar Battery"
                              ? product.details.voltage_range
                              : product.type == "Industrial"
                                ? product.details.voltage_range
                                : product.details.local_warranty}
                          </span>
                          {product.type == "Industrial"
                            ? "DOD"
                            : product.type == "Solar Battery"
                              ? "Nominal Voltage"
                              : "Local Warranty"}
                        </li>
                        <li>
                          <span>{product.details.weight} </span>
                          Weight
                        </li>
                      </ul>
                    </div>
                    <div className="product-info-bottom">
                      <div className="real-estate-agent go-top">
                        {/* <div className="agent-img">
                          <Link to="/team-details">
                            <img
                              src={product.agent.image}
                              alt={product.agent.name}
                            />
                          </Link>
                        </div> */}
                        <div className="agent-brief">
                          <h6>
                            {/* <Link
                            to="/team-details"
                            >
                              {product.agent.name}
                            </Link> */}
                            {/* {product.agent.name} */}
                          </h6>
                          <small>{product.agent.role}</small>
                        </div>
                      </div>
                      {/* <div className="product-hover-action">
                        <ul>
                          <li>
                            <a
                              href="#"
                              title="Quick View"
                              data-bs-toggle="modal"
                              data-bs-target="#quick_view_modal"
                            >
                              <i className="flaticon-expand" />
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              title="Wishlist"
                              data-bs-toggle="modal"
                              data-bs-target="#liton_wishlist_modal"
                            >
                              <i className="flaticon-heart-1" />
                            </a>
                          </li>
                          <li>
                            <a
                              href="product-details.html"
                              title="Product Details"
                            >
                              <i className="flaticon-add" />
                            </a>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* <div className="row ltn__product-slider-item-three-active slick-arrow-1">
              
              <div className="col-lg-12">
                <div className="ltn__product-item ltn__product-item-4 text-center---">
                  <div className="product-img go-top">
                    <Link to="/product-details">
                      <img
                        src={publicUrl + "assets/img/product-3/1.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="product-badge">
                      <ul>
                        <li className="sale-badge bg-green">For Rent</li>
                      </ul>
                    </div>
                    <div className="product-img-location-gallery">
                      <div className="product-img-location go-top">
                        <ul>
                          <li>
                            <Link to="/contact">
                              <i className="flaticon-pin" /> Belmont Gardens,
                              Chicago
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="product-img-gallery go-top">
                        <ul>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-camera" /> 4
                            </Link>
                          </li>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-film" /> 2
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="product-info">
                    <div className="product-price">
                      <span>
                        $34,900<label>/Month</label>
                      </span>
                    </div>
                    <h2 className="product-title go-top">
                      <Link to="/product-details">New Apartment Nice View</Link>
                    </h2>
                    <div className="product-description">
                      <p>
                        Beautiful Huge 1 Family House In Heart Of <br />
                        Westbury. Newly Renovated With New Wood
                      </p>
                    </div>
                    <ul className="ltn__list-item-2 ltn__list-item-2-before">
                      <li>
                        <span>
                          3 <i className="flaticon-bed" />
                        </span>
                        Bedrooms
                      </li>
                      <li>
                        <span>
                          2 <i className="flaticon-clean" />
                        </span>
                        Bathrooms
                      </li>
                      <li>
                        <span>
                          3450{" "}
                          <i className="flaticon-square-shape-design-interface-tool-symbol" />
                        </span>
                        square Ft
                      </li>
                    </ul>
                  </div>
                  <div className="product-info-bottom">
                    <div className="real-estate-agent go-top">
                      <div className="agent-img">
                        <Link to="/team-details">
                          <img
                            src={publicUrl + "assets/img/blog/author.jpg"}
                            alt="#"
                          />
                        </Link>
                      </div>
                      <div className="agent-brief">
                        <h6>
                          <Link to="/team-details">William Seklo</Link>
                        </h6>
                        <small>Estate Agents</small>
                      </div>
                    </div>
                    <div className="product-hover-action">
                      <ul>
                        <li>
                          <a
                            href="#"
                            title="Quick View"
                            data-bs-toggle="modal"
                            data-bs-target="#quick_view_modal"
                          >
                            <i className="flaticon-expand" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            title="Wishlist"
                            data-bs-toggle="modal"
                            data-bs-target="#liton_wishlist_modal"
                          >
                            <i className="flaticon-heart-1" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="product-details.html"
                            title="Product Details"
                          >
                            <i className="flaticon-add" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-12">
                <div className="ltn__product-item ltn__product-item-4 text-center---">
                  <div className="product-img go-top">
                    <Link to="/product-details">
                      <img
                        src={publicUrl + "assets/img/product-3/2.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="product-badge">
                      <ul>
                        <li className="sale-badge bg-green---">For Sale</li>
                      </ul>
                    </div>
                    <div className="product-img-location-gallery">
                      <div className="product-img-location go-top">
                        <ul>
                          <li>
                            <Link to="/contact">
                              <i className="flaticon-pin" /> Belmont Gardens,
                              Chicago
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="product-img-gallery go-top">
                        <ul>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-camera" /> 4
                            </Link>
                          </li>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-film" /> 2
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="product-info">
                    <div className="product-price">
                      <span>
                        $34,900<label>/Month</label>
                      </span>
                    </div>
                    <h2 className="product-title go-top">
                      <Link to="/product-details">Modern Apartments</Link>
                    </h2>
                    <div className="product-description">
                      <p>
                        Beautiful Huge 1 Family House In Heart Of <br />
                        Westbury. Newly Renovated With New Wood
                      </p>
                    </div>
                    <ul className="ltn__list-item-2 ltn__list-item-2-before">
                      <li>
                        <span>
                          3 <i className="flaticon-bed" />
                        </span>
                        Bedrooms
                      </li>
                      <li>
                        <span>
                          2 <i className="flaticon-clean" />
                        </span>
                        Bathrooms
                      </li>
                      <li>
                        <span>
                          3450{" "}
                          <i className="flaticon-square-shape-design-interface-tool-symbol" />
                        </span>
                        square Ft
                      </li>
                    </ul>
                  </div>
                  <div className="product-info-bottom">
                    <div className="real-estate-agent go-top">
                      <div className="agent-img">
                        <Link to="/team-details">
                          <img
                            src={publicUrl + "assets/img/blog/author.jpg"}
                            alt="#"
                          />
                        </Link>
                      </div>
                      <div className="agent-brief">
                        <h6>
                          <Link to="/team-details">William Seklo</Link>
                        </h6>
                        <small>Estate Agents</small>
                      </div>
                    </div>
                    <div className="product-hover-action">
                      <ul>
                        <li>
                          <a
                            href="#"
                            title="Quick View"
                            data-bs-toggle="modal"
                            data-bs-target="#quick_view_modal"
                          >
                            <i className="flaticon-expand" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            title="Wishlist"
                            data-bs-toggle="modal"
                            data-bs-target="#liton_wishlist_modal"
                          >
                            <i className="flaticon-heart-1" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="product-details.html"
                            title="Product Details"
                          >
                            <i className="flaticon-add" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-12">
                <div className="ltn__product-item ltn__product-item-4 text-center---">
                  <div className="product-img go-top">
                    <Link to="/product-details">
                      <img
                        src={publicUrl + "assets/img/product-3/3.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="product-badge">
                      <ul>
                        <li className="sale-badge bg-green">For Rent</li>
                      </ul>
                    </div>
                    <div className="product-img-location-gallery">
                      <div className="product-img-location go-top">
                        <ul>
                          <li>
                            <Link to="/contact">
                              <i className="flaticon-pin" /> Belmont Gardens,
                              Chicago
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="product-img-gallery go-top">
                        <ul>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-camera" /> 4
                            </Link>
                          </li>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-film" /> 2
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="product-info">
                    <div className="product-price">
                      <span>
                        $34,900<label>/Month</label>
                      </span>
                    </div>
                    <h2 className="product-title go-top">
                      <Link to="/product-details">Comfortable Apartment</Link>
                    </h2>
                    <div className="product-description">
                      <p>
                        Beautiful Huge 1 Family House In Heart Of <br />
                        Westbury. Newly Renovated With New Wood
                      </p>
                    </div>
                    <ul className="ltn__list-item-2 ltn__list-item-2-before">
                      <li>
                        <span>
                          3 <i className="flaticon-bed" />
                        </span>
                        Bedrooms
                      </li>
                      <li>
                        <span>
                          2 <i className="flaticon-clean" />
                        </span>
                        Bathrooms
                      </li>
                      <li>
                        <span>
                          3450{" "}
                          <i className="flaticon-square-shape-design-interface-tool-symbol" />
                        </span>
                        square Ft
                      </li>
                    </ul>
                  </div>
                  <div className="product-info-bottom">
                    <div className="real-estate-agent go-top">
                      <div className="agent-img">
                        <Link to="/team-details">
                          <img
                            src={publicUrl + "assets/img/blog/author.jpg"}
                            alt="#"
                          />
                        </Link>
                      </div>
                      <div className="agent-brief">
                        <h6>
                          <Link to="/team-details">William Seklo</Link>
                        </h6>
                        <small>Estate Agents</small>
                      </div>
                    </div>
                    <div className="product-hover-action">
                      <ul>
                        <li>
                          <a
                            href="#"
                            title="Quick View"
                            data-bs-toggle="modal"
                            data-bs-target="#quick_view_modal"
                          >
                            <i className="flaticon-expand" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            title="Wishlist"
                            data-bs-toggle="modal"
                            data-bs-target="#liton_wishlist_modal"
                          >
                            <i className="flaticon-heart-1" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="product-details.html"
                            title="Product Details"
                          >
                            <i className="flaticon-add" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-12">
                <div className="ltn__product-item ltn__product-item-4 text-center---">
                  <div className="product-img go-top">
                    <Link to="/product-details">
                      <img
                        src={publicUrl + "assets/img/product-3/4.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="product-badge">
                      <ul>
                        <li className="sale-badge bg-green">For Rent</li>
                      </ul>
                    </div>
                    <div className="product-img-location-gallery">
                      <div className="product-img-location go-top">
                        <ul>
                          <li>
                            <Link to="/contact">
                              <i className="flaticon-pin" /> Belmont Gardens,
                              Chicago
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="product-img-gallery go-top">
                        <ul>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-camera" /> 4
                            </Link>
                          </li>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-film" /> 2
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="product-info">
                    <div className="product-price">
                      <span>
                        $34,900<label>/Month</label>
                      </span>
                    </div>
                    <h2 className="product-title go-top">
                      <Link to="/product-details">
                        Luxury villa in Rego Park{" "}
                      </Link>
                    </h2>
                    <div className="product-description">
                      <p>
                        Beautiful Huge 1 Family House In Heart Of <br />
                        Westbury. Newly Renovated With New Wood
                      </p>
                    </div>
                    <ul className="ltn__list-item-2 ltn__list-item-2-before">
                      <li>
                        <span>
                          3 <i className="flaticon-bed" />
                        </span>
                        Bedrooms
                      </li>
                      <li>
                        <span>
                          2 <i className="flaticon-clean" />
                        </span>
                        Bathrooms
                      </li>
                      <li>
                        <span>
                          3450{" "}
                          <i className="flaticon-square-shape-design-interface-tool-symbol" />
                        </span>
                        square Ft
                      </li>
                    </ul>
                  </div>
                  <div className="product-info-bottom">
                    <div className="real-estate-agent go-top">
                      <div className="agent-img">
                        <Link to="/team-details">
                          <img
                            src={publicUrl + "assets/img/blog/author.jpg"}
                            alt="#"
                          />
                        </Link>
                      </div>
                      <div className="agent-brief">
                        <h6>
                          <Link to="/team-details">William Seklo</Link>
                        </h6>
                        <small>Estate Agents</small>
                      </div>
                    </div>
                    <div className="product-hover-action">
                      <ul>
                        <li>
                          <a
                            href="#"
                            title="Quick View"
                            data-bs-toggle="modal"
                            data-bs-target="#quick_view_modal"
                          >
                            <i className="flaticon-expand" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            title="Wishlist"
                            data-bs-toggle="modal"
                            data-bs-target="#liton_wishlist_modal"
                          >
                            <i className="flaticon-heart-1" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="product-details.html"
                            title="Product Details"
                          >
                            <i className="flaticon-add" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-12">
                <div className="ltn__product-item ltn__product-item-4 text-center---">
                  <div className="product-img go-top">
                    <Link to="/product-details">
                      <img
                        src={publicUrl + "assets/img/product-3/5.jpg"}
                        alt="#"
                      />
                    </Link>
                    <div className="product-badge">
                      <ul>
                        <li className="sale-badge bg-green">For Rent</li>
                      </ul>
                    </div>
                    <div className="product-img-location-gallery">
                      <div className="product-img-location go-top">
                        <ul>
                          <li>
                            <Link to="/contact">
                              <i className="flaticon-pin" /> Belmont Gardens,
                              Chicago
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="product-img-gallery go-top">
                        <ul>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-camera" /> 4
                            </Link>
                          </li>
                          <li>
                            <Link to="/product-details">
                              <i className="fas fa-film" /> 2
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="product-info">
                    <div className="product-price">
                      <span>
                        $34,900<label>/Month</label>
                      </span>
                    </div>
                    <h2 className="product-title go-top">
                      <Link to="/product-details">
                        Beautiful Flat in Manhattan{" "}
                      </Link>
                    </h2>
                    <div className="product-description">
                      <p>
                        Beautiful Huge 1 Family House In Heart Of <br />
                        Westbury. Newly Renovated With New Wood
                      </p>
                    </div>
                    <ul className="ltn__list-item-2 ltn__list-item-2-before">
                      <li>
                        <span>
                          3 <i className="flaticon-bed" />
                        </span>
                        Bedrooms
                      </li>
                      <li>
                        <span>
                          2 <i className="flaticon-clean" />
                        </span>
                        Bathrooms
                      </li>
                      <li>
                        <span>
                          3450{" "}
                          <i className="flaticon-square-shape-design-interface-tool-symbol" />
                        </span>
                        square Ft
                      </li>
                    </ul>
                  </div>
                  <div className="product-info-bottom">
                    <div className="real-estate-agent go-top">
                      <div className="agent-img">
                        <Link to="/team-details">
                          <img
                            src={publicUrl + "assets/img/blog/author.jpg"}
                            alt="#"
                          />
                        </Link>
                      </div>
                      <div className="agent-brief">
                        <h6>
                          <Link to="/team-details">William Seklo</Link>
                        </h6>
                        <small>Estate Agents</small>
                      </div>
                    </div>
                    <div className="product-hover-action">
                      <ul>
                        <li>
                          <a
                            href="#"
                            title="Quick View"
                            data-bs-toggle="modal"
                            data-bs-target="#quick_view_modal"
                          >
                            <i className="flaticon-expand" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            title="Wishlist"
                            data-bs-toggle="modal"
                            data-bs-target="#liton_wishlist_modal"
                          >
                            <i className="flaticon-heart-1" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="product-details.html"
                            title="Product Details"
                          >
                            <i className="flaticon-add" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
          </div> */}
          </div>
        </div>
        <div className="ltn__modal-area ltn__add-to-cart-modal-area">
          <div className="modal fade" id="liton_wishlist_modal" tabIndex={-1}>
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="ltn__quick-view-modal-inner">
                    <div className="modal-product-item">
                      <div className="row">
                        <div className="col-12">
                          <div className="modal-product-img">
                            <img
                              src={publicUrl + "assets/img/product/7.png"}
                              alt="#"
                            />
                          </div>
                          <div className="modal-product-info go-top">
                            <h5>
                              <Link to="/product-details">
                                Brake Conversion Kit
                              </Link>
                            </h5>
                            <p className="added-cart">
                              <i className="fa fa-check-circle" /> Successfully
                              added to your Wishlist
                            </p>
                            <div className="btn-wrapper">
                              <Link
                                to="/wishlist"
                                className="theme-btn-1 btn btn-effect-1"
                              >
                                View Wishlist
                              </Link>
                            </div>
                          </div>
                          {/* additional-info */}
                          <div className="additional-info d-none">
                            <p>
                              We want to give you <b>10% discount</b> for your
                              first order, <br /> Use discount code at checkout
                            </p>
                            <div className="payment-method">
                              <img
                                src={publicUrl + "assets/img/icons/payment.png"}
                                alt="#"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ltn__modal-area ltn__quick-view-modal-area">
          <div className="modal fade" id="quick_view_modal" tabIndex={-1}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                    {/* <i class="fas fa-times"></i> */}
                  </button>
                </div>
                <div className="modal-body">
                  <div className="ltn__quick-view-modal-inner">
                    <div className="modal-product-item">
                      <div className="row">
                        <div className="col-lg-6 col-12">
                          <div className="modal-product-img">
                            <img
                              src={publicUrl + "assets/img/product/4.png"}
                              alt="#"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="modal-product-info">
                            <div className="product-ratting">
                              <ul>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="fas fa-star-half-alt" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#">
                                    <i className="far fa-star" />
                                  </a>
                                </li>
                                <li className="review-total">
                                  {" "}
                                  <a href="#"> ( 95 Reviews )</a>
                                </li>
                              </ul>
                            </div>
                            <h3>Brake Conversion Kit</h3>
                            <div className="product-price">
                              <span>$149.00</span>
                              <del>$165.00</del>
                            </div>
                            <div className="modal-product-meta ltn__product-details-menu-1">
                              <ul>
                                <li>
                                  <strong>Categories:</strong>
                                  <span className="go-top">
                                    <Link to="/blog">Parts</Link>
                                    <Link to="/blog">Car</Link>
                                    <Link to="/blog">Seat</Link>
                                    <Link to="/blog">Cover</Link>
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="ltn__product-details-menu-2">
                              <ul>
                                <li>
                                  <div className="cart-plus-minus">
                                    <input
                                      type="text"
                                      defaultValue="02"
                                      name="qtybutton"
                                      className="cart-plus-minus-box"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    className="theme-btn-1 btn btn-effect-1"
                                    title="Add to Cart"
                                    data-bs-toggle="modal"
                                    data-bs-target="#add_to_cart_modal"
                                  >
                                    <i className="fas fa-shopping-cart" />
                                    <span>ADD TO CART</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <hr />
                            <div className="ltn__social-media">
                              <ul>
                                <li>Share:</li>
                                <li>
                                  <a href="#" title="Facebook">
                                    <i className="fab fa-facebook-f" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#" title="Twitter">
                                    <i className="fab fa-twitter" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#" title="Linkedin">
                                    <i className="fab fa-linkedin" />
                                  </a>
                                </li>
                                <li>
                                  <a href="#" title="Instagram">
                                    <i className="fab fa-instagram" />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ltn__modal-area ltn__add-to-cart-modal-area">
          <div className="modal fade" id="add_to_cart_modal" tabIndex={-1}>
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="ltn__quick-view-modal-inner">
                    <div className="modal-product-item">
                      <div className="row">
                        <div className="col-12">
                          <div className="modal-product-img">
                            <img
                              src={publicUrl + "assets/img/product/1.png"}
                              alt="#"
                            />
                          </div>
                          <div className="modal-product-info go-top">
                            <h5 className="go-top">
                              <Link to="/product-details">
                                Brake Conversion Kit
                              </Link>
                            </h5>
                            <p className="added-cart">
                              <i className="fa fa-check-circle" />
                              Successfully added to your Cart
                            </p>
                            <div className="btn-wrapper">
                              <Link
                                to="/cart"
                                className="theme-btn-1 btn btn-effect-1"
                              >
                                View Cart
                              </Link>
                              <Link
                                to="/checkout"
                                className="theme-btn-2 btn btn-effect-2"
                              >
                                Checkout
                              </Link>
                            </div>
                          </div>
                          {/* additional-info */}
                          <div className="additional-info d-none">
                            <p>
                              We want to give you <b>10% discount</b> for your
                              first order, <br /> Use discount code at checkout
                            </p>
                            <div className="payment-method">
                              <img
                                src={publicUrl + "assets/img/icons/payment.png"}
                                alt="#"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SolarInverterProducts;
